import { ValueAddedOP, TechnicalProductOP } from '@cemex-core/cmx-api';
import { Action } from '@ngrx/store';

export enum AddedValueActionTypes {
  LOAD_ADDED_VALUES_OP = '[RMS Open Platform Added Value] Load added values',
  LOAD_ADDED_VALUES_NOT_FORMULATING_OP = '[RMS Open Platform Added Value] Load added values not formulating',
  LOAD_AVAILABLE_ADDED_VALUES_COMPLETED_OP = '[RMS Open Platform Added value] Load complete',
  CLEAN_NULL_ADDED_VALUES_OP = '[RMS Open Platform Added value] Clean added values',
  RESET_OP = '[RMS Open Platform Added Value] Reset',
  RESET_OP_FORM_ID = '[RMS Open Platform Added Value] Reset by form id',
  ADDED_VALUES_SPECIALIZED_OP = '[RMS Open Platform Added Value] Specialized',
  LOAD_TEMPERATURE_VALUES = '[RMS Open Platform Added value] Load temperature values',
  LOAD_TEMPERATURE_VALUES_COMPLETED = '[RMS Open Platform Added value] Load temperature values completed',
  LOAD_ADDED_VALUES_RMX_UL_OP = '[RMS Open Platform Added Value] Load rmx ul added values',
  LOAD_AVAILABLE_ADDED_VALUES_COMPLETED_RMX_UL_OP = '[RMS Open Platform Added value] Load rmx ul complete',
}

export class LoadAddedValuesActionOP implements Action {
  readonly type = AddedValueActionTypes.LOAD_ADDED_VALUES_OP;

  constructor(
    public payload: {
      productCode: string;
      index: number;
      addedValues?: ValueAddedOP[];
      contractCode?: string;
      formId: number;
    },
  ) {}
}

export class LoadAddedValuesCompleteActionOP implements Action {
  readonly type = AddedValueActionTypes.LOAD_AVAILABLE_ADDED_VALUES_COMPLETED_OP;

  constructor(
    public payload: {
      productCode: string;
      addedValues: ValueAddedOP[];
      index: number;
      technicalProduct: TechnicalProductOP[];
      contractCode: string;
      formId: number;
    },
  ) {}
}

export class AddedValuesCleanActionOP implements Action {
  readonly type = AddedValueActionTypes.CLEAN_NULL_ADDED_VALUES_OP;

  constructor() {}
}

export class AddedValuesResetActionOP implements Action {
  readonly type = AddedValueActionTypes.RESET_OP;

  constructor() {}
}

export class AddedValuesResetActionOPByFormID implements Action {
  readonly type = AddedValueActionTypes.RESET_OP_FORM_ID;

  constructor(
    public payload: {
      formId: number;
    },
  ) {}
}
export class LoadAddedValuesNotFormulatingActionOP implements Action {
  readonly type = AddedValueActionTypes.LOAD_ADDED_VALUES_NOT_FORMULATING_OP;

  constructor(
    public payload: {
      productCode: string;
      index: number;
      addedValues?: ValueAddedOP[];
      contractCode?: string;
      formId: number;
    },
  ) {}
}

export class ValueAddedsSpecalizedActionOP implements Action {
  readonly type = AddedValueActionTypes.ADDED_VALUES_SPECIALIZED_OP;

  constructor(
    public payload: {
      formdId: number;
      specialized: boolean;
      nothasNotAlloedCombinations: boolean;
    },
  ) {}
}
export class LoadTemperatureValues implements Action {
  readonly type = AddedValueActionTypes.LOAD_TEMPERATURE_VALUES;

  constructor(
    public payload: {
      productCode: string;
      contractCode?: string;
      formId: number;
    },
  ) {}
}

export class LoadTemperatureValuesCompleted implements Action {
  readonly type = AddedValueActionTypes.LOAD_TEMPERATURE_VALUES_COMPLETED;

  constructor(
    public payload: {
      addedValues: ValueAddedOP[];
      formId: number;
    },
  ) {}
}

export class LoadAddedValuesActionRMXULOP implements Action {
  readonly type = AddedValueActionTypes.LOAD_ADDED_VALUES_RMX_UL_OP;

  constructor(
    public payload: {
      productCode: string;
      index: number;
      addedValues?: ValueAddedOP[];
      contractCode?: string;
      formId: number;
    },
  ) {}
}

export class LoadAddedValuesCompleteActionRMXULOP implements Action {
  readonly type = AddedValueActionTypes.LOAD_AVAILABLE_ADDED_VALUES_COMPLETED_RMX_UL_OP;

  constructor(
    public payload: {
      productCode: string;
      addedValues: ValueAddedOP[];
      index: number;
      technicalProduct: TechnicalProductOP[];
      contractCode: string;
      formId: number;
    },
  ) {}
}

export type AddedValuesActions =
  | LoadAddedValuesActionOP
  | LoadAddedValuesCompleteActionOP
  | AddedValuesResetActionOP
  | AddedValuesCleanActionOP
  | ValueAddedsSpecalizedActionOP
  | LoadAddedValuesNotFormulatingActionOP
  | LoadTemperatureValues
  | LoadTemperatureValuesCompleted
  | AddedValuesResetActionOPByFormID
  | LoadAddedValuesActionRMXULOP
  | LoadAddedValuesCompleteActionRMXULOP;
